import React from 'react';

// This hook does the same thing that useState does with one simple difference
// is that useState triggers re-render(s) on state change, while ref doesn't
// In other words, this is just a more elegant way to use refs as if you were using states
export const useMutableRef = (initialValue) => {
  const ref = React.useRef(initialValue);

  const mutate = (value) => {
    ref.current = value;
  };

  return [
    ref, // do not return ref.current (since it doesn't work the same way)
    mutate,
  ];
};
